import { createContext, useContext } from "react";
import type { ManualLogPreselect } from "./manual-signal-log-model";

/**
 * Opens the "Add to today" manual-log modal, optionally pre-selected to a
 * specific form. Provided by the app shell (where the modal is mounted) so any
 * surface (a capture-prompt attention card, a coach mark) can open it without
 * owning the modal or drilling props through the router.
 */
export type OpenManualLog = (preselect?: ManualLogPreselect | null) => void;

const ManualLogContext = createContext<OpenManualLog | null>(null);

export const ManualLogProvider = ManualLogContext.Provider;

export function useOpenManualLog(): OpenManualLog {
  return useContext(ManualLogContext) ?? (() => {});
}
